<template>
  <analytics-sub-page
    title="Rewards Analytics"
    icon="gift"
    css-class="analytics-rewards"
    default-label="Rewards"
    :get-sheet-config="getSheetConfig"
  >
    <rewards-metrics ref="metricsRef" />
  </analytics-sub-page>
</template>

<script setup>
import { ref } from 'vue';
import AnalyticsSubPage from '@/components/AnalyticsSubPage.vue';
import RewardsMetrics from '@/pages/analyticsApp/components/RewardsMetrics.vue';

const metricsRef = ref(null);

const getSheetConfig = () => metricsRef.value?.getPdfData?.() || {};
</script>
